import { COLLECTION_KEYS } from '../MobileMarket/mobileMarketConstants';
import React, { useCallback } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import classNames from 'classnames';
import useHorizontalScroll from '../../../hooks/useHorizontalScroll';
import { useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../../../modules/Location/locationSelectors';
import ButtonMove from '../../../components/ButtonMove/ButtonMove';
import MobileWidgetGradientCardNameIcon
    from '../MobileWidgets/MobileWidgetGradientCardsNameIcon/MobileWidgetGradientCardNameIcon';
import {
    MobileRecommendedScrollStyled,
    MobileRecommendedStyled,
} from './styled/MobileRecommendedStyled';
import BinIcon from '../../../components/icon/Icon';
import useMobileWidgetCardsAssets from '../MobileWidgets/MobileWidgetCards/useMobileWidgetCardsAssets';

const RECOMMENDED_ASSETS_MAX_COUNT = 5;

function MobileRecommended() {
    const { getLangPath } = useLangContext();
    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);
    const {
        scrollRef,
        onScrollLeft,
        onScrollRight,
        props: mouseProps,
        isDragging,
        isOverflowing,
    } = useHorizontalScroll<HTMLDivElement>();
    const {
        assets: renderAssetsList,
        collectionTitle,
        openCollectionSlide,
    } = useMobileWidgetCardsAssets(COLLECTION_KEYS.POPULAR, RECOMMENDED_ASSETS_MAX_COUNT);

    const handleSeeAllClick = useCallback(() => openCollectionSlide(COLLECTION_KEYS.POPULAR), [openCollectionSlide]);

    if (!renderAssetsList.length) return null;

    return <MobileRecommendedStyled>
        <div className={'d-flex align-items-center justify-content-between mb-2'}>
            <h6 className={'text-secondary mb-0'}>{collectionTitle}</h6>
            <div className={'d-flex align-items-center text-secondary gap-1 fw600'} onClick={handleSeeAllClick}>
                <span>{getLangPath('lite_version.market.see_all')}</span>
                <BinIcon name={'IcForward'} size={16}/>
            </div>
        </div>
        <MobileRecommendedScrollStyled ref={scrollRef} {...mouseProps} className={classNames({
            'custom-scrollbar': !isPlatformMobile,
            'hidden-scrollbar': isPlatformMobile,
            mobile: isPlatformMobile,
        })}>
            {renderAssetsList.map(asset => <MobileWidgetGradientCardNameIcon key={asset.symbol}
                                                                             symbol={asset.symbol}
                                                                             disabled={isDragging}
                                                                             collectionKey={COLLECTION_KEYS.POPULAR}/>)}
        </MobileRecommendedScrollStyled>

        {
            !isPlatformMobile && isOverflowing &&
            <>
                <ButtonMove className={'backdrop-filter-blur100 arrow-left'} direction={'left'} size={'xs'}
                            onClick={onScrollLeft}/>
                <ButtonMove className={'backdrop-filter-blur100 arrow-right'} direction={'right'} size={'xs'}
                            onClick={onScrollRight}/>
            </>
        }
    </MobileRecommendedStyled>;
}

export default MobileRecommended;
